const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/artists/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/* eslint-disable @typescript-eslint/no-use-before-define */
import { getFindAllArtistsQueryOptions, getFindArtistGenresQueryOptions } from '@api';
import { createTableQuerySchema } from '@common';
import { createFileRoute } from '@tanstack/react-router';
import { t } from 'i18next';
const artistsSearchSchema = createTableQuerySchema({});
export const Route = createFileRoute('/_rootLayout/artists/')({
  validateSearch: search => artistsSearchSchema.parse(search),
  loader: async ({
    context: {
      queryClient
    },
    location
  }) => {
    const search = artistsSearchSchema.parse(location.search);
    queryClient.ensureQueryData(getFindAllArtistsQueryOptions(search));
    queryClient.ensureQueryData(getFindArtistGenresQueryOptions());
    return {
      crumb: t('NAVIGATION.ARTISTS'),
      to: '/artists'
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});